<template>
  <div>
    <v-tabs v-model="tab" background-color="secondary" dark fixed-tabs>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab to="/admin/badge/coach">Coach Badges</v-tab>
      <v-tab to="/admin/badge/challenge">Dot Badges</v-tab>
      <v-tab to="/admin/badge/consistency">Consistency Badges</v-tab>
      <v-tab to="/admin/badge/event">Event Badges</v-tab>
      <v-tab to="/admin/badge/custom">Custom badges</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item id="/admin/badge/coach">
        <coach-badges />
      </v-tab-item>
      <v-tab-item id="/admin/badge/challenge">
        <dot-badges />
      </v-tab-item>
      <v-tab-item id="/admin/badge/consistency">
        <consistency-badges />
      </v-tab-item>
      <v-tab-item id="/admin/badge/event">
        <event-badges />
      </v-tab-item>
      <v-tab-item id="/admin/badge/custom">
        <custom-badges />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CoachBadges from "./CoachBadges";
import DotBadges from "./DotBadges";
import ConsistencyBadges from "./ConsistencyBadges";
import EventBadges from "./EventBadges";
import CustomBadges from "./CustomBadges";

export default {
  name: "BadgeAdmin",
  components: {
    CoachBadges,
    DotBadges,
    ConsistencyBadges,
    EventBadges,
    CustomBadges
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>
